<template>
  <div class="template-default d-flex flex-column">
    <div class="top-bar-desktop d-none d-lg-block">
      <div
        class="d-flex align-items-center justify-content-between ml-5 p-3"
        :class="$permissions.currentCompany ? 'mt-4' : 'mt-2'"
      >
        <div class="d-flex align-items-end gap-4">
          <img src="@/assets/images/zeus/zeus_full.svg" height="30" />
        </div>

        <template v-if="$permissions.currentCompany">
          <div>
            <span class="text-neutral-300">
              Central
            </span>
            <strong>{{ $permissions.currentCompany.company.name }}</strong>
          </div>
          <bp-button
            @click="leaveCompany"
            class="mr-3"
            size="md"
            variant="outlined"
            color="neutral"
            label="Sair"
          />
        </template>
        <div v-else class="d-flex">
          <company-dropdown v-if="companies.length" :companies="companies" />
          <profile-drop-down @logout="logoutDialog = true" />
        </div>
      </div>
    </div>
    <div
      class="top-bar-mobile d-flex align-items-center justify-content-between pl-9 pb-2 d-lg-none pr-4"
    >
      <router-link class="d-lg-none" :to="{ name: 'home' }">
        <img
          v-if="$permissions.currentCompany"
          :src="$config.get('symbol')"
          height="26"
        />
        <img v-else class="ml-3" :src="$config.get('logo_black')" height="24" />
      </router-link>
      <div v-if="$permissions.currentCompany" class="pt-4">
        <p class="mobile-business-name">
          {{ $permissions.currentCompany.company.name }}
        </p>
      </div>
      <div class="d-flex align-items-center ml-3">
        <template v-if="$permissions.currentCompany">
          <bp-button
            @click="leaveCompany"
            class="mr-4 mt-2"
            size="md"
            variant="outlined"
            color="neutral"
            label="Sair"
          />
        </template>
        <template v-else>
          <!-- <whatsapp-button></whatsapp-button> -->
          <company-dropdown v-if="companies.length" :companies="companies" />
          <profile-drop-down @logout="logoutDialog = true" class="ml-2" />
        </template>
      </div>
    </div>
    <confirmation
      v-model="logoutDialog"
      @confirm="logout"
      text="Tem certeza que deseja sair?"
      confirm-button-text="Sair"
    />
    <side-menu />

    <main class="flex-fill position-relative">
      <div
        class="slot-wrapper"
        :class="{
          'container-fluid pt-9 mt-9 Logo pb-9': !$route.meta.viewContainer
        }"
      >
        <slot v-if="!loading" />
        <div v-else class="text-center p-9">
          <b-spinner variant="primary" style="width: 3rem; height: 3rem;" />
        </div>
      </div>
    </main>
    <!-- <crm-config-modal v-model="CRMConfigVisible" /> -->
  </div>
</template>
<script>
import SideMenu from "@/components/menu/SideMenu.vue";
import CompanyDropdown from "@/components/user/CompanyDropdown";
import ProfileDropDown from "@/components/user/ProfileDropDown/ProfileDropDown";
import { setToken } from "@/setup/api.js";
import { get } from "lodash";
import { mapState } from "vuex";
export default {
  components: {
    ProfileDropDown,
    CompanyDropdown,
    SideMenu
  },
  data() {
    return {
      logoutDialog: false,
      menuButtonTimeout: null,
      openContext: ""
    };
  },
  computed: {
    ...mapState(["loading"]),
    ...mapState("crm", ["configVisible"]),
    CRMConfigVisible: {
      get() {
        return this.$store.state.crm.configVisible;
      },
      set(val) {
        this.$store.commit("crm/setConfigVisible", val);
      }
    },
    reversedCourses() {
      return [...this.courses].reverse();
    },
    companies() {
      const base = get(this.$user, "user.company_base");
      return get(this.$user, "user.companies", []).filter(
        c => c.company.id !== base
      );
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
    leaveCompany() {
      setToken(this.$user.user.token);
      setTimeout(() => {
        window.location.href = "/";
      }, 1);
    }
  }
  // mounted() {
  //   insert_script_for_modals();
  // }
};
</script>

<style lang="scss">
.template-default {
  min-height: 100vh;
  display: flex;
  position: relative;
  &.sale {
    background: #e63946;
    footer * {
      color: white !important;
    }
  }
  .top-bar-desktop {
    position: fixed;
    background: #fff;
    top: 0;
    width: 100%;
    left: 0;
    height: 72px;
    z-index: 4;
    border-bottom: 1px solid #dbd6e1;
  }
  .top-bar-mobile {
    background: #f8f8f9;
    width: 100%;
    position: fixed;
    z-index: 2;
    background: #fff;
    .mobile-business-name {
      max-width: calc(100vw - 170px);
      font-weight: 500;
      overflow: hidden;
      word-wrap: nowrap;
      text-overflow: ellipsis;
    }
  }
  main {
    background: #fafbfc;
    width: 100%;
    position: relative;
    @media screen and (min-width: 992px) {
      width: calc(100% - 72px);
      margin-left: 72px;
    }
  }
  .slot-wrapper {
    display: flex;
    flex-direction: column;
    transition: 0.15s padding ease;
    min-height: 100vh;
    @media screen and (max-width: 991px) {
      padding-top: 60px;
    }
    @media screen and (min-width: 992px) {
      padding-top: 72px;
    }
  }

  .account-menu {
    position: absolute;
    top: 24px;
    right: 24px;
    z-index: 1;
    .dropdown-toggle {
      border-radius: 32px;
      max-width: 32px;
      min-width: 32px;
      max-height: 32px;
      min-height: 32px;
      border: 1px solid #5576ec;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      &::after {
        display: none;
      }
    }
  }
  .profile-dropdown-wrapper {
    position: absolute;
    top: 0%;
    right: 1%;
    z-index: 1;
  }

  .dropdown-toggle-no-caret,
  .avatar-perfil {
    padding: 0;
  }
  .limit-user-name {
    font-weight: 500 !important;
  }

  // V2 form-group
  .form-group {
    .el-input__inner {
      height: 40px;
      min-height: 40px;
      border-color: #a9a9a9;
      background: transparent;
      &::placeholder {
        color: #a9a9a9;
      }
    }
    .el-select__caret {
      color: #666666;
    }
  }

  .nav-item {
    @media screen and (max-width: 991px) {
      flex: 1;
      text-align: center;
    }
    a {
      padding: 12px;
      &.active,
      &:hover {
        font-size: 14px;
      }
    }
  }

  .by-nre {
    opacity: 0.4;
    transition: 0.2s opacity;
    font-size: 10px;

    &:hover {
      opacity: 1;
    }

    img {
      height: 8px;
      width: 17.5px;
    }
  }
}
</style>
